module.exports = __webpack_public_path__ + "img/map2_p.b94bd356.svg";